import { render, staticRenderFns } from "./BlacklistItem.vue?vue&type=template&id=58e1b565&scoped=true&"
import script from "./BlacklistItem.vue?vue&type=script&lang=js&"
export * from "./BlacklistItem.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistItem.vue?vue&type=style&index=0&id=58e1b565&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e1b565",
  null
  
)

export default component.exports